import styled from '@emotion/styled';
import { useEffect, useState, useContext } from 'react';
import { ChatRoomItem } from './ChatRoomItem';
import { ChatRoom } from './ChatRoom';
import { buyerChatContext } from 'application/contexts/useBuyerChatRoom';
import { AboutService } from 'ui/components/buyer/features/AboutService';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { mqUser, mqMin } from 'utils/responsive';

const tabs = ['メッセージのやり取り', '面談日の設定'];

const descriptions: { [key: string]: string[] } = {
    メッセージのやり取り: [
        '仲介会社からのオファーを受けると、こちらのメッセージが開通されます。',
        '開通したら、仲介会社からのメッセージをお待ち下さい。',
    ],
    面談日の設定: ['仲介会社とのチャットページにて、面談日の設定、管理を行うことが可能です。'],
};

const Wrapper = styled.div`
    font-size: var(--font-medium);
    margin: 0 auto;
    background-color: #f8f9fd;
    padding: 18px 50px;

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    width: 100%;

    ${mqUser('SP')} {
        flex-direction: column;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    width: 100%;
    justify-content: space-between;
`;

const ListContainer = styled(Container)`
    flex-basis: 30%;
    min-height: calc(100vh -110px);
    justify-content: flex-start;
    overflow-y: auto;
    padding-right: 15px;

    ${mqUser('SP')} {
        padding-right: 0;
        display: ${({ $isHidden }: { $isHidden?: boolean }) => ($isHidden ? 'none' : 'flex')};
    }
`;

const ChatRoomContainer = styled(Container)`
    flex-basis: 69%;
    background-color: #fff;
    height: calc(100vh - 110px);

    ${mqUser('SP')} {
        display: ${({ $isHidden }: { $isHidden?: boolean }) => ($isHidden ? 'none' : 'flex')};
        height: calc(100vh - 80px);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1000;
    }
`;

const SearchInput = styled.input`
    padding: 10px;
    border: 1px solid #5f5f5f;
    border-radius: 1px;
    font-size: var(--font-medium);

    &:focus {
        outline: none;
    }
`;

const NoMessage = styled.div`
    font-size: var(--font-medium);
    color: #5f5f5f;
    text-align: center;
    margin-top: 20px;
`;

const ChatItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;

    ${mqMin('NARROW')} {
        height: calc(100% - 240px);
    }
`;

export const ChatRoomList: React.FC = () => {
    const {
        filteredChatRooms,
        selectedChatRoom,
        unreadIds,
        setSelectedChatRoom,
        keyword,
        setKeyword,
        fetchData,
        loading,
    } = useContext(buyerChatContext);

    useEffect(() => {
        fetchData();
    }, []);

    const [isSP] = useState(window.innerWidth <= 799);
    const [showChatRoom, setShowChatRoom] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const handleChatRoomSelect = (chatRoom: any) => {
        setSelectedChatRoom(chatRoom);
        if (isSP) {
            setShowChatRoom(true);
        }
    };

    const handleBackToList = () => {
        if (isSP) {
            setShowChatRoom(false);
        }
    };

    return (
        <Wrapper>
            <PageTitle title="メッセージ" />
            <AboutService tabs={tabs} descriptions={descriptions} showTipsForQuestionnaires />
            <FlexContainer>
                <ListContainer $isHidden={isSP && showChatRoom}>
                    <h4>マッチした仲介会社を検索する</h4>
                    <SearchInput
                        placeholder="企業名で検索"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />
                    <ChatItemsContainer>
                        {filteredChatRooms.map((chatRoom, index) => (
                            <ChatRoomItem
                                key={index}
                                chatRoom={chatRoom}
                                unread={unreadIds.includes(chatRoom.id)}
                                selected={selectedChatRoom?.id === chatRoom.id}
                                onClick={() => handleChatRoomSelect(chatRoom)}
                            />
                        ))}
                    </ChatItemsContainer>
                </ListContainer>
                <ChatRoomContainer $isHidden={isSP && !showChatRoom}>
                    {filteredChatRooms.length === 0 && !loading ? (
                        <NoMessage>まだメッセージが有りません。 仲介会社からのメッセージをお待ち下さい。</NoMessage>
                    ) : selectedChatRoom ? (
                        <ChatRoom onBack={handleBackToList} />
                    ) : (
                        <NoMessage>左のメニューからチャットルームを選択してください。</NoMessage>
                    )}
                </ChatRoomContainer>
            </FlexContainer>
        </Wrapper>
    );
};
